<template>
  <div class="map-main">
    <!-- <div class="top">
      <div class="top-sel"></div>
    </div> -->
    <div class="map-box">
      <div class="not_3d_map" v-if="mapList.length == 0">
        <h3>该学校暂未开通3D地图</h3>
        <h3>如有需要请咨询<span>0371-88056789</span></h3>
        <div class="disp_text">
          通过对学院环境进行建模，建立学院电子三维地图，利用网络通信技术，形象展示学院安防设施部署情况，基建和安防信息完整呈现在云管理平台上，系统具备立体性，方位性，直观性，真实性等特点，有效实现对学院安防的直观，动态监管
        </div>
        <a class="button" href="http://119.3.205.252:9123/" target="_blank"
          >进入3D地图演示</a
        >
      </div>
      <el-carousel class="iframe-box" :autoplay="false" v-else height="760px">
        <el-carousel-item v-for="(item, index) in mapList" :key="index">
          <iframe
            v-if="item.tdmUrl != ''"
            :src="item.tdmUrl"
            width="1724px"
            height="760px"
            frameborder="0"
          >
          </iframe>
          <div class="not_3d_map" v-else>
            <h3>{{ item.schoolName }}暂未开通3D地图</h3>
            <h3>如有需要请咨询<span>0371-88056789</span></h3>
            <div class="disp_text">
              通过对学院环境进行建模，建立学院电子三维地图，利用网络通信技术，形象展示学院安防设施部署情况，基建和安防信息完整呈现在云管理平台上，系统具备立体性，方位性，直观性，真实性等特点，有效实现对学院安防的直观，动态监管
            </div>
            <a class="button" href="http://119.3.205.252:9123/" target="_blank"
              >进入3D地图演示</a
            >
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
export default {
  name: "safetyMap",
  props: {
    type: {
      type: String
    }
  },
  data() {
    return {
      mapList: []
    };
  },
  created() {
    if (this.type == "thoseIn") {
      this.editU3D();
    } else {
      this.getList();
    }
  },
  methods: {
    async editU3D() {
      this.centerDialogVisible = true;
      let res = await this.$Http.getEudU3DInfo({
        eduId: this.eduInfo.eduId
      });
      if (res.code == 200) {
        this.mapList = [];
        let obj = {
          schoolName: this.eduInfo.eduBuresuName || "",
          tdmUrl: res.data.tdmUrl || ""
        };
        this.mapList.push(obj);
      } else if (res.code == 101) {
        this.mapList = [];
      } else {
        this.mapList = [];
      }
    },
    async getList() {
      let res = await this.$Http.getDepartmentU3dList({
        eduId: this.eduInfo.eduId
      });
      if (res.code == 200) {
        this.mapList = res.data || [];
      } else if (res.code == 101) {
        this.mapList = [];
      } else {
        this.mapList = [];
      }
    },
    async getHeadList() {
      let res = await this.$Http.getHeadDepartmentU3dList({
        collegeId: this.eduInfo.eduId
      });
      if (res.code == 200) {
        this.mapList = res.data || [];
      } else if (res.code == 101) {
        this.mapList = [];
      } else {
        this.mapList = [];
      }
    }
  },
  computed: {
    eduInfo() {
      return JSON.parse(sessionStorage.getItem("eduInfo"));
    }
  },
  watch: {
    type: function(val) {
      if (val == "thoseIn") {
        this.editU3D();
      } else {
        this.getList();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.corner {
  background: #58a;
  background: linear-gradient(-45deg, transparent 20px, #58a 0);
}
.map-main {
  width: 100%;
  height: calc(100% - 56px);
  display: flex;
  justify-content: center;
  align-items: center;
  .top {
    padding: 20px 60px 0 90px;
    display: flex;
    justify-content: flex-end;
    .top-sel {
      display: flex;
      justify-content: center;
      align-items: center;
      .sel-option {
        cursor: pointer;
        color: #fff;
        width: 84px;
        height: 81px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
.map-box {
  // height: 870px;
  height: 760px;
  width: 1920px;
  display: flex;
  justify-content: center;
  align-items: center;
  // background-color: rgba(7, 7, 44, 0.6);
  // background-size: 100% 100%;
  .iframe-box {
    //   background: linear-gradient(-45deg,transparent 20px,#58a 0);
    background: url("~@/assets/img/schoolBigData/safety-map-bg.png") center
      center no-repeat;
    height: 760px;
    width: 1724px;
    border-radius: 2px;
  }
}
.not_3d_map {
  height: 760px;
  width: 1724px;
  text-align: center;
  color: rgb(185, 217, 230);
  padding: 250px 32%;
  background-color: rgba(7, 7, 44, 0.6);
  h3 {
    font-size: 20px;
    margin: 15px;
  }
}
.disp_text {
  display: block;
  text-align: left;
  text-indent: 30px;
  margin-top: 2rem;
  line-height: 26px;
}
.button {
  width: 130px;
  height: 50px;
  margin-top: 10px;
  display: inline-block;
  background: #337ab7;
  color: #fff;
  line-height: 50px;
  border-radius: 5px;
  &:hover {
    background: #23527c;
  }
}
</style>
